"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const NumberTracing = ({ onScore }) => {
  const [currentNumber, setCurrentNumber] = useState(1)
  const [traced, setTraced] = useState(false)

  const traceNumber = () => {
    setTraced(true)
    onScore(10)
    setTimeout(() => {
      setCurrentNumber((prev) => (prev % 4) + 1)
      setTraced(false)
    }, 2000)
  }

  return (
    <div className="lesson-card card-orange">
      <h2 className="lesson-title" style={{ color: "#c2410c" }}>
        Обводим цифры ✍️
      </h2>

      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <h3 style={{ fontSize: "1.25rem", marginBottom: "16px" }}>Обведи цифру {currentNumber}</h3>
        <div style={{ position: "relative", display: "inline-block" }}>
          <div
            style={{
              fontSize: "9rem",
              fontWeight: "bold",
              color: "#d1d5db",
              userSelect: "none",
            }}
          >
            {currentNumber}
          </div>
          {traced && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                fontSize: "9rem",
                fontWeight: "bold",
                color: "#ea580c",
                animation: "pulse 1s infinite",
              }}
            >
              {currentNumber}
            </div>
          )}
        </div>
      </div>

      <div style={{ marginBottom: "24px", display: "flex", justifyContent: "center" }}>
        <AbacusDisplay value={currentNumber} />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
          marginBottom: "24px",
          maxWidth: "400px",
          margin: "0 auto 24px",
        }}
      >
        {Array.from({ length: 3 }, (_, i) => (
          <div
            key={i}
            style={{
              fontSize: "3.75rem",
              fontWeight: "bold",
              color: "#e5e7eb",
              backgroundColor: "white",
              padding: "16px",
              borderRadius: "8px",
              border: "2px dashed #d1d5db",
              textAlign: "center",
            }}
          >
            {currentNumber}
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center" }}>
        <button onClick={traceNumber} className="nav-button primary" style={{ backgroundColor: "#ea580c" }}>
          {traced ? "Отлично! ✨" : "Обвести цифру! ✏️"}
        </button>
      </div>
    </div>
  )
}

export default NumberTracing
